import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import BrandLogos from "./components/BrandLogos";
import StatsSection from "./components/StatsSection";
import ProductFeatures from "./components/ProductFeatures";
import BonusFeatures from "./components/BonusFeatures";
import Testimonials from "./components/Testimonials";
import StickyCards from "./components/StickyCards";
import FAQ from "./components/FAQ";
import ProcessSteps from "./components/ProcessSteps";
import ContactUs from "./components/ContactUs";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import SEO from "./components/SEO";

const Home = () => {
  const stickyCardData = [
    {
      id: 1,
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&q=80',
      alt: 'Dashboard Analytics'
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80',
      alt: 'Data Visualization'
    },
    {
      id: 3,
      image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=1200&q=80',
      alt: 'Team Collaboration'
    },
    {
      id: 4,
      image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1200&q=80',
      alt: 'Campaign Management'
    },
    {
      id: 5,
      image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=1200&q=80',
      alt: 'Influencer Discovery'
    },
  ];

  return (
    <div className="min-h-screen">
      <SEO />
      <Navbar />
      <HeroSection />
      <BrandLogos />
      {/* <StatsSection /> */}
      <ProductFeatures />
      <BonusFeatures />
      {/* <Testimonials /> */}
      <ContactUs />
      <FAQ />
      <ProcessSteps />
      {/* <StickyCards cards={stickyCardData} /> */}
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/cookies" element={<CookiePolicy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
